import React, { useState } from "react";
import "../css/contactus.scss";
import { Link } from "react-router-dom";

function Contact() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    setTimeout(() => {
      setShowSuccess(true);
      setFormData({
        fullName: "",
        email: "",
        message: "",
      });
      setIsSubmitting(false);

      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    }, 1000);
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="contact">
      <div className="contact__container">
        <h1 className="contact__title">CONTACT US</h1>

        <div className="contact__intro">
          <p className="contact__intro-text">We'd love to hear from you.</p>
          <p className="contact__intro-text">
            For general questions, order support, shipping, or tracking,
            contact us at wares@tuddlepetgoods.club.
          </p>
          <p className="contact__intro-text">
            For custom jewelry and engagement-ring inquiries, include your
            preferred materials, size, timing, and budget range in your message.
          </p>
        </div>

        {showSuccess && (
          <div className="contact__success">
            Thank you for your message! We'll get back to you soon.
          </div>
        )}

        <form className="contact__form" onSubmit={handleSubmit}>
          <h2 className="contact__form-title">CONTACT US</h2>
          <div className="contact__form-line"></div>

          <div className="contact__field">
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              placeholder="Full Name"
              className={errors.fullName ? "contact__input--error" : ""}
            />
            {errors.fullName && (
              <p className="contact__error">{errors.fullName}</p>
            )}
          </div>

          <div className="contact__field">
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email"
              className={errors.email ? "contact__input--error" : ""}
            />
            {errors.email && <p className="contact__error">{errors.email}</p>}
          </div>

          <div className="contact__field">
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Message"
              rows={8}
              className={errors.message ? "contact__textarea--error" : ""}
            />
            {errors.message && (
              <p className="contact__error">{errors.message}</p>
            )}
          </div>

          <button
            type="submit"
            className="contact__submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "SENDING..." : "SEND"}
          </button>
        </form>

        <p className="contact__footer">
          By submitting this form, you acknowledge our{" "}
          <Link to="/privacy" onClick={toTop} className="contact__link">
            Privacy Policy
          </Link>{" "}
          and agree to our{" "}
          <Link to="/terms" onClick={toTop} className="contact__link">
            Terms of Service
          </Link>{" "}
          apply.
        </p>
      </div>
    </div>
  );
}

export default Contact;
